// Optional "Special Requests" cart attribute.
// Saves to the cart as the shopper types (and on blur), and keeps the
// cart drawer and cart page copies in sync. No validation: it's optional.
if (!customElements.get('special-requests')) {
  customElements.define(
    'special-requests',
    class SpecialRequests extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('textarea');
        if (!this.input) return;
        this.lastSaved = this.input.value.trim();

        this.input.addEventListener('input', () => {
          this.sync();
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.save(), 800);
        });
        this.input.addEventListener('change', () => this.save());
        this.input.addEventListener('blur', () => this.save());
      }

      disconnectedCallback() {
        // The drawer re-renders when quantities change; don't lose a pending save.
        if (this.timer) this.save();
      }

      sync() {
        document.querySelectorAll('special-requests textarea').forEach((el) => {
          if (el !== this.input) el.value = this.input.value;
        });
      }

      save() {
        clearTimeout(this.timer);
        this.timer = null;
        if (!this.input) return;
        const value = this.input.value.trim();
        if (value === this.lastSaved) return;
        this.lastSaved = value;
        // An empty value removes the attribute, so a blank field never shows on the order.
        return fetch(`${routes.cart_update_url}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { 'Special Requests': value } }),
        }).catch((e) => console.error(e));
      }
    }
  );
}